import { RacemapAPIClient } from '@racemap/utilities/api-client';
import { isDefined } from '@racemap/utilities/functions/validation';
import { produce } from 'immer';
import { Tristate } from 'src/components/utils/tristateTask';

import type { StoreApi } from 'zustand';
import type { DraftState, State } from '../../reducers';
import type { TrackersActions } from '../trackers_reducers';

const apiClient = RacemapAPIClient.fromWindowLocation();

export const createSimCardActions = (
  set: StoreApi<State>['setState'],
  get: StoreApi<State>['getState'],
): Pick<TrackersActions, 'activateSimCards' | 'terminateSimCards'> => ({
  activateSimCards: async (trackerIds) => {
    try {
      set(
        produce((s: DraftState) => {
          s.trackers.savingState = Tristate.SPINNING;
        }),
      );
      const trackers = get().trackers.items;
      const simIds = trackerIds
        .map((id) => trackers.get(id.toHexString())?.simCard?.id)
        .filter(isDefined);

      const { numSimsToActivate, numFailed } = await apiClient.activateSims({ simIds });
      await get().trackers.actions.loadData();

      return { numSucceeded: numSimsToActivate - numFailed, numFailed };
    } finally {
      set(
        produce((s: DraftState) => {
          s.trackers.savingState = Tristate.NORMAL;
        }),
      );
    }
  },

  terminateSimCards: async (trackerIds) => {
    try {
      set(
        produce((s: DraftState) => {
          s.trackers.savingState = Tristate.SPINNING;
        }),
      );
      const trackers = get().trackers.items;
      const simIds = trackerIds
        .map((id) => trackers.get(id.toHexString())?.simCard?.id)
        .filter(isDefined);

      const { numSimsToTerminate, numFailed } = await apiClient.terminateSims({ simIds });
      await get().trackers.actions.loadData();

      return { numSucceeded: numSimsToTerminate - numFailed, numFailed };
    } finally {
      set(
        produce((s: DraftState) => {
          s.trackers.savingState = Tristate.NORMAL;
        }),
      );
    }
  },
});
